module.exports = __webpack_public_path__ + "img/santa-fe.05356900.jpg";